import styled, {keyframes} from 'styled-components';
import {commonPalette} from 'styles/palette';

const spin = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  display: inline-block;
`;

export const Circle = styled.div`
  animation: 0.8s linear infinite ${spin};
  border-color: ${p => (p.color ? p.color : p.theme.mainColor)} ${commonPalette.surfaceBackdrop}
    ${commonPalette.surfaceBackdrop};
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  display: block;
  height: ${p => p.size};
  width: ${p => p.size};

  ${p =>
    (p.center || p.centerX) &&
    `
    margin-left: calc(${p.size} / -2);
  `};

  ${p =>
    (p.center || p.centerY) &&
    `
    margin-top: calc(${p.size} / -2);
  `};

  ${p =>
    p.centerAbs &&
    `
    left: 50%;
    position: absolute;
    top: 50%;
  `};
`;
